import { DocumentNode, gql } from '@apollo/client';
import {
  Box,
  HStack,
  Image,
  LinkBox,
  LinkOverlay,
  Stack,
  Text,
} from '@chakra-ui/react';
import NextLink from 'next/link';
import * as React from 'react';

import { EventTime } from '@/components/EventTime';
import { getAppropriateEventLink } from '@/hooks/getAppropriateEventLink';
import { Card } from '@/imports/ui/chakra/components/Card';
import { ImageFallback } from '@/imports/ui/chakra/components/ImageFallback';
import { ImageFallbackMavericks } from '@/imports/ui/chakra/components/ImageFallbackMavericks';

import { UpcomingEvent_EventFragment } from './graphql-types/UpcomingEvent_EventFragment';

export const UpcomingEvent: React.FC<{ event: UpcomingEvent_EventFragment }> & {
  eventFragment: DocumentNode;
} = ({ event }) => {
  const eventLink = getAppropriateEventLink(event);
  const { startDate, endDate } = event;

  return (
    <NextLink href={eventLink}>
      <Card shadow="xs">
        <Image
          borderTopRadius="xl"
          src={event.bannerImage?.imageProxy ?? undefined}
          alt={event.name}
          fallback={
            <ImageFallbackMavericks borderTopRadius="xl" title={event.name} />
          }
        />
        <Box px="4" py="3">
          <Text textStyle="bodyStrong" noOfLines={2}>
            {event.name}
          </Text>
          <Text noOfLines={2} color="gray.600">
            {startDate && endDate ? (
              <EventTime startDate={startDate} endDate={endDate} />
            ) : (
              'TBD'
            )}
          </Text>
        </Box>
      </Card>
    </NextLink>
  );
};

UpcomingEvent.eventFragment = gql`
  fragment UpcomingEvent_EventFragment on EventV2 {
    _id
    bannerImage {
      _id
      imageProxy(input: { ar: "8:3", w: 1600, fit: "fill", fill: "blur" })
    }
    name
    startDate
    endDate

    ...GetAppropriateEventLink_EventFragment
  }
  ${getAppropriateEventLink.eventFragment}
`;
